<template>
  <div class="sl_border">
  <div class="content search">
    <div class="search_title"> 검색결과</div>
    <div class="search_body">'{{returnBoardName()}}'에서 {{page.total}}개가 검색되었습니다.</div>
    <div class="search_border"></div>
    <div class="b_layout">
      <div class="b_cont" v-for="(board, index) in boardData" :key="`search${board.wr_id}`" @click="goDetail(board.wr_id)">
        <div class="b_image" :style="`background-image:url(${returnImage(board)})`"></div>
        <div class="b_text">
          <div class="bt_title">  {{board.wr_subject}}</div>
          <div class="bt_body" v-html="decodeHtml(board.wr_content)">
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import util from "@/mixins/util";
import imageOption from "@/mixins/imageOption";


export default {
        name: "BoardListSearchLayout",
        mixins: [imageOption],
        components: {},
        props: {
          boardData: {
            type: Array,
            default: () => {
              return []
            }
          },
          page:{},
          boardName:''
        },
        data() {
            return {

            }
        },
        beforeRouterEnter() {
        },
        created() {
        },
        mounted() {

        },
        beforeDestroy() {
        },
        destroyed() {
        },
        computed: {},
        methods: {
          goDetail(idx) {
            this.$router.push(`/${this.boardName}/${idx}?tab=${this.boardName}`)
          },
            returnImage(data) {
                if (this.hasFile(data)) {
                    return `${data.File.File[0].org_url}?${this.setImageOptions(270, 194, 'jpg')}`
                }
                else { return ''}
            },
            hasFile(data) {
                return !util.isEmpty(data.File) && data.File.hasOwnProperty('File') && !util.isEmpty(data.File.File)
            },
          returnBoardName(){
            let type = this.boardName
            switch (type) {
              case "business":
                return '주요사업'
              case "financial":
                return '재무보고'
              case "news":
                return '뉴스'
              case "donate":
                return '나눔 & 배움'
              case "album":
                return '앨범'
            }
          },
            decodeHtml(html = '') {
                let img_tag = /<IMG(.*?)>/gi;
                let video_tag = /<iframe(.*?)>(.*?)<\/iframe>/gi;
                html = html.replace(img_tag, "");
                html = html.replace(video_tag, "");

                return util.htmlDecode(html);
            },
        },
        watch: {},
    }
</script>

<style scoped>

</style>